import React from 'react';
import { getLocaleWordContent } from '@/utils/language.util';
export default function SignUpHandler() {
    return (
        <div className="join_btn_box">
            <input type="submit" value={getLocaleWordContent('회원가입')} className="btn01" />
        </div>
    );
}
